(function() {

  var linkFunction = function($scope, element, attrs) {
    // console.log("Available Refills Info Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function($scope, UserSession) {
    // console.log("Available Refills Info Controller Func: ", $scope);
    $scope.wcmContent = wcmContent;
    $scope.numRefills = UserSession.accountData.numRefills;
  }

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/availableRefillsInfo/availableRefillsInfo.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "userSession"];
  angular.module('cvsApp').directive('availableRefillsInfo', directiveFunction);

})();
